import { Link } from "react-router-dom";

/**
 * Porté depuis apps/web/app/(shop)/cgu/page.tsx : `next/link` → `Link` de
 * react-router-dom (`href` → `to`), `generateMetadata` abandonné (hors
 * périmètre — cf. lot SEO/prérendu séparé).
 *
 * CGU — régit l'usage du SITE (compte, comportement attendu, contenu),
 * distinctes des CGV (`/cgv`, régissent la TRANSACTION d'achat). Même
 * gabarit/ton que `/cgv` : cadre général, pas un document juridique validé
 * (avertissement en pied de page).
 */
export function CguPage() {
  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">
        Conditions générales d&apos;utilisation
      </h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <div>
          <h2 className="font-display text-base font-semibold text-ink">1. Objet</h2>
          <p className="mt-1">
            Les présentes conditions générales d&apos;utilisation (« CGU ») régissent l&apos;accès et
            l&apos;usage du site VVS — Vendez-Vous eShop (« le site »), distinctement des{" "}
            <Link to="/cgv" className="text-navy underline hover:text-golddark">
              conditions générales de vente
            </Link>{" "}
            qui régissent, elles, les commandes passées sur le site.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">2. Accès au site</h2>
          <p className="mt-1">
            La consultation du catalogue est libre, sans création de compte. Certaines
            fonctionnalités (favoris, suivi de commandes, passage de commande) nécessitent la création
            d&apos;un compte, associé à un numéro de téléphone et une adresse email, via un code de
            vérification envoyé par email — sans mot de passe.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">3. Compte utilisateur</h2>
          <p className="mt-1">
            Chaque compte est personnel et rattaché à un numéro de téléphone unique. L&apos;utilisateur
            est responsable de la confidentialité des codes de vérification qui lui sont envoyés et
            s&apos;engage à fournir des informations exactes lors de la création de son compte et de ses
            commandes.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">4. Usage attendu</h2>
          <p className="mt-1">
            L&apos;utilisateur s&apos;engage à utiliser le site conformément à sa destination (consulter
            le catalogue, gérer son compte, passer des commandes réelles) et à ne pas tenter de
            perturber son fonctionnement, d&apos;accéder à des données ne lui appartenant pas, ou de
            passer des commandes dans une intention frauduleuse.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">5. Propriété intellectuelle</h2>
          <p className="mt-1">
            Le nom « VVS — Vendez-Vous eShop », son logo, la structure et le contenu éditorial du
            site (textes, mise en page) sont la propriété de VVS ou de ses vendeurs référencés. Toute
            reproduction non autorisée est interdite. Les photos et descriptions produits restent la
            propriété de leurs vendeurs respectifs.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">6. Disponibilité du site</h2>
          <p className="mt-1">
            VVS met en œuvre des moyens raisonnables pour maintenir le site accessible, sans garantir
            une disponibilité continue et ininterrompue (maintenance, incident technique). VVS ne
            saurait être tenu responsable d&apos;une indisponibilité temporaire du site.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">7. Données personnelles et cookies</h2>
          <p className="mt-1">
            L&apos;usage du site implique le traitement de certaines données personnelles et le dépôt
            de cookies strictement nécessaires à son fonctionnement — voir la{" "}
            <Link to="/confidentialite" className="text-navy underline hover:text-golddark">
              politique de confidentialité
            </Link>{" "}
            et la{" "}
            <Link to="/politique-cookies" className="text-navy underline hover:text-golddark">
              politique de cookies
            </Link>
            .
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">8. Modification des CGU</h2>
          <p className="mt-1">
            VVS peut faire évoluer les présentes CGU pour refléter l&apos;évolution du site. La
            version en vigueur est celle publiée sur cette page.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">9. Droit applicable</h2>
          <p className="mt-1">
            Les présentes CGU sont soumises au droit ivoirien. En cas de litige, l&apos;utilisateur est
            invité à contacter VVS en priorité afin de rechercher une solution amiable.
          </p>
        </div>

        <p className="border-t border-line pt-4 text-xs text-muted/80">
          Ce texte constitue un cadre général structurant, rédigé pour refléter le fonctionnement
          actuel du site. Il ne constitue pas un document juridique définitif et doit être validé par
          un professionnel du droit avant toute mise en production définitive.
        </p>
      </div>
    </div>
  );
}
